export const OPTHINES = {
  voteName: '2019poject/2019breakthelimitone',
  themeColor: {
    activeBgColor: '#e43524',
    inactiveBgColor: 'rgb(3, 43, 78)',
  },
  placeholder: '搜索团队名称/作品名称',
  tabs: [
    {
      tabName: '活动介绍',
      tabPath: '/2019BreakTheLimit/desc',
    },
    // {
    //   tabName: '我要报名',
    //   tabPath: '/2019BreakTheLimit/signUp',
    // },
    {
      tabName: '作品展示',
      tabPath: '/2019BreakTheLimit/firstStage',
    },
    {
      tabName: '相关新闻',
      tabPath: '/2019BreakTheLimit/relativeNews',
    },
  ],
  mustSearch: 'Button',
  buttonBg: 'rgb(100, 134,205 )',
  number: {
    mustRank: true,
  },
  name: true,
  content: true,
  user: true,
  checkBox: false,
};
